/* eslint-disable */
import React, { useState, useRef } from "react";
import "./Login1.css";
import { useNavigate, Link } from "react-router-dom";
import { Alert } from "react-bootstrap";
import { useUserAuth } from "../../context/UserAuthContext";
import { ref, onValue, push, getDatabase, get } from "firebase/database"; //deepa audit logs
import { db } from "../../firebase-config";

/**
 * Helper function to get a field value supporting both camelCase and PascalCase
 * @param {Object} obj - The object to get the field from
 * @param {string} camelCase - camelCase version of field name (e.g., 'email')
 * @param {string} pascalCase - PascalCase version of field name (e.g., 'Email')
 * @returns {*} The field value or undefined
 */
const getField = (obj, camelCase, pascalCase) => {
  if (!obj) return undefined;
  return obj[camelCase] !== undefined ? obj[camelCase] : obj[pascalCase];
};

/**
 * Sanitize email to create a valid Firebase key (must match the population script)
 * @param {string} email - The email address
 * @returns {string} Sanitized email key
 */
const sanitizeEmailKey = (email) => {
  if (!email) return null;
  return email
    .toLowerCase()
    .replace(/\./g, '_')
    .replace(/\$/g, '_')
    .replace(/#/g, '_')
    .replace(/\[/g, '_')
    .replace(/\]/g, '_')
    .replace(/\//g, '_')
    .replace(/@/g, '_at_');
};
import { update } from "firebase/database";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Function to log user login events //deepa audit logs
const logUserLogin = (userData, outcome, context = {}, adminName = "") => {
  // Non-blocking: fire and forget
  (async () => {
    try {
      // Initialize database
      const db = getDatabase();
      // Use admin name from param or localStorage for admin-specific path
      const admin =
        adminName || localStorage.getItem("adminName") || "Unknown_Admin";
      const logRef = ref(
        db,
        `superadmin/admins/${admin}/audit_logs/Authentication/User_Login`
      );

      // Add user agent info if available
      if (typeof window !== "undefined") {
        context.user_agent = navigator.userAgent;
      }

      // Fetch location asynchronously without blocking
      try {
        const response = await fetch("https://ipapi.co/json/");
        const locationData = await response.json();
        context.location = {
          city: locationData.city || "Unknown",
          region: locationData.region || "Unknown",
          country: locationData.country_name || "Unknown",
          ip: locationData.ip || "Unknown",
        };
      } catch (locationError) {
        console.error("Error fetching location data:", locationError);
        context.location = { error: "Location data unavailable" };
      }

      // Log with location data
      push(logRef, {
        timestamp: new Date().toISOString(),
        user: userData,
        outcome: outcome,
        context: context,
      });
    } catch (error) {
      console.error("Error logging user login:", error);
    }
  })();
};

// Function to log failed login attempts //deepa audit logs
const logFailedLogin = (
  attemptedUser,
  reason,
  context = {},
  adminName = ""
) => {
  // Non-blocking: fire and forget
  (async () => {
    try {
      const db = getDatabase();
      // Use admin name from param or localStorage for admin-specific path
      const admin =
        adminName || localStorage.getItem("adminName") || "Unknown_Admin";
      const logRef = ref(
        db,
        `superadmin/admins/${admin}/audit_logs/Authentication/Failed_Login`
      );

      // Add user agent info if available
      if (typeof window !== "undefined") {
        context.user_agent = navigator.userAgent;
      }

      // Fetch location asynchronously without blocking
      try {
        const response = await fetch("https://ipapi.co/json/");
        const locationData = await response.json();
        context.location = {
          city: locationData.city || "Unknown",
          region: locationData.region || "Unknown",
          country: locationData.country_name || "Unknown",
          ip: locationData.ip || "Unknown",
        };
      } catch (locationError) {
        console.error("Error fetching location data:", locationError);
        context.location = { error: "Location data unavailable" };
      }

      // Log with location data
      push(logRef, {
        timestamp: new Date().toISOString(),
        attempted_user: attemptedUser,
        reason: reason,
        context: context,
      });
    } catch (error) {
      console.error("Error logging failed login:", error);
    }
  })();
};

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { logIn } = useUserAuth();
  const navigate = useNavigate();
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false); // ✅ Track privacy policy acceptance
  const [userId, setUserId] = useState(null); // ✅ Store technician's Firebase path for updating privacy
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);

  // ✅ Ref for Scrollable Policy Content
  const policyRef = useRef(null);

  const handleforgotpassword = () => {
    navigate("/ForgotPassword");
  };

  // ✅ Scroll Event to Check When User Reaches Bottom
  const handleScroll = () => {
    if (policyRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = policyRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        // Small margin for precision
        setHasScrolledToBottom(true);
      }
    }
  };

  const handleAcceptPrivacy = async () => {
    setLoading(true);
    try {
      if (!userId) {
        setError("Error: User ID not found.");
        setLoading(false);
        return;
      }

      const userRef = ref(db, userId);
      await update(userRef, { privacyAccepted: true });

      setShowPrivacyPolicy(false);

      // ✅ Retrieve the user's role to determine redirection
      const role = localStorage.getItem("role");
      if (role === "technician") {
        navigate("/Technician"); // Redirect to Technician panel
      } else if (role === "doctor") {
        navigate("/DoctorPanel"); // Redirect to Doctor panel
      } else if (role === "hod") {
        navigate("/DoctorPanel"); // Redirect HOD to Doctor panel with HOD privileges
      } else if (role === "admin") {
        navigate("/Admin"); // ✅ Now supports Admins!
      } else if (role === "student") {
        navigate("/Students"); // Redirect to Students panel
      } else {
        setError("Error: Role not recognized.");
      }
    } catch (error) {
      console.error("Error updating privacy status:", error);
      setError("Failed to update privacy status.");
    }
    setLoading(false);
  };

  // 2. Your handleSubmit function - OPTIMIZED with PARALLEL queries for instant login
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    // ⏱️ Start timing the login process
    console.time("🔐 Total Login Time");
    const loginStartTime = performance.now();

    try {
      const userEmail = document.getElementById("userEmail").value;
      const userPassword = document.getElementById("userPassword").value;
      const emailKey = sanitizeEmailKey(userEmail);

      // 🚀 PARALLEL EXECUTION: Run Firebase Auth AND index query simultaneously!
      console.time("  ⏱️ Step 1+2: Parallel Auth + Index Query");
      const userIndexRef = ref(db, `user_auth_index/${emailKey}`);
      
      const [authResult, indexSnapshot] = await Promise.all([
        logIn(email, password),           // Firebase Auth
        get(userIndexRef)                 // Index query
      ]);
      console.timeEnd("  ⏱️ Step 1+2: Parallel Auth + Index Query");

      if (!indexSnapshot.exists()) {
        // User not found in index, log and show error
        logFailedLogin(userEmail, "User not found in auth index", {
          ip_address: "client-ip",
        });
        setError("Invalid email or password");
        setLoading(false);
        console.timeEnd("🔐 Total Login Time");
        return;
      }

      const indexData = indexSnapshot.val();
      const userRole = indexData.role;
      const userPath = indexData.path;
      const adminName = indexData.adminName;
      const fullName = indexData.fullName;
      const storedPassword = indexData.password;
      const storedEmail = indexData.email;
      const privacyAccepted = indexData.privacyAccepted || false;
      const doctorRole = indexData.doctorRole || '';

      // Step 3: Verify password matches (NO database fetch needed - password is in index!)
      console.time("  ⏱️ Step 3: Password verification");
      if (storedEmail?.toLowerCase() !== userEmail.toLowerCase() || storedPassword !== userPassword) {
        logFailedLogin(userEmail, "Invalid credentials", {
          ip_address: "client-ip",
        });
        setError("Invalid email or password");
        setLoading(false);
        console.timeEnd("  ⏱️ Step 3: Password verification");
        console.timeEnd("🔐 Total Login Time");
        return;
      }
      console.timeEnd("  ⏱️ Step 3: Password verification");

      // Step 4: Handle role-based login and localStorage setup
      console.time("  ⏱️ Step 4: Role processing & redirect");

      switch (userRole) {
        case "superadmin":
          localStorage.setItem("role", "superadmin");
          localStorage.setItem("senderEmail", storedEmail);

          logUserLogin(
            { username: "Super Admin", email: storedEmail, roles: "superadmin" },
            "success",
            { ip_address: "client-ip" }
          );

          // Navigate FIRST, then stop loading (instant redirect)
          navigate("/SuperAdmin", { replace: true });
          setLoading(false);
          break;

        case "admin":
          localStorage.setItem("role", "admin");
          localStorage.setItem("adminName", fullName);
          localStorage.setItem("senderEmail", storedEmail);

          logUserLogin(
            { username: fullName, email: storedEmail, roles: "admin" },
            "success",
            { ip_address: "client-ip" },
            fullName
          );

          if (!privacyAccepted) {
            setUserId(userPath);
            setShowPrivacyPolicy(true);
            setLoading(false);
          } else {
            // Navigate FIRST for instant redirect
            navigate("/Admin", { replace: true });
            setLoading(false);
          }
          break;

        case "technician":
          localStorage.setItem("role", "technician");
          localStorage.setItem("Name", fullName);
          localStorage.setItem("techName", fullName);
          localStorage.setItem("adminName", adminName);
          localStorage.setItem("senderEmail", storedEmail);
          localStorage.setItem("techEmail", storedEmail);

          logUserLogin(
            { username: fullName, email: storedEmail, roles: "technician" },
            "success",
            { ip_address: "client-ip" },
            adminName
          );

          if (!privacyAccepted) {
            setUserId(userPath);
            setShowPrivacyPolicy(true);
            setLoading(false);
          } else {
            // Navigate FIRST for instant redirect
            navigate("/Technician", { replace: true });
            setLoading(false);
          }
          break;

        case "doctor":
        case "hod":
          // doctorRole is already extracted from indexData above
          const isHOD = userRole === "hod" || doctorRole.toLowerCase().includes("hod");

          localStorage.setItem("role", isHOD ? "hod" : "doctor");
          localStorage.setItem("docName", fullName);
          localStorage.setItem("adminName", adminName);
          localStorage.setItem("adminEmail", storedEmail);
          localStorage.setItem("docEmail", storedEmail);
          localStorage.setItem("senderEmail", storedEmail);
          localStorage.setItem("doctorRole", doctorRole);

          logUserLogin(
            { username: fullName, email: storedEmail, roles: isHOD ? "hod" : "doctor" },
            "success",
            { ip_address: "client-ip" },
            adminName
          );

          if (!privacyAccepted) {
            setUserId(userPath);
            setShowPrivacyPolicy(true);
            setLoading(false);
          } else {
            // Navigate FIRST for instant redirect
            navigate("/DoctorPanel", { replace: true });
            setLoading(false);
          }
          break;

        case "student":
          localStorage.setItem("role", "student");
          localStorage.setItem("Name", fullName);
          localStorage.setItem("studentName", fullName);
          localStorage.setItem("adminName", adminName);
          localStorage.setItem("senderEmail", storedEmail);

          logUserLogin(
            { username: fullName, email: storedEmail, roles: "student" },
            "success",
            { ip_address: "client-ip" },
            adminName
          );

          if (!privacyAccepted) {
            setUserId(userPath);
            setShowPrivacyPolicy(true);
            setLoading(false);
          } else {
            // Navigate FIRST for instant redirect
            navigate("/Students", { replace: true });
            setLoading(false);
          }
          break;

        default:
          logFailedLogin(userEmail, "Unknown role", { ip_address: "client-ip", role: userRole });
          setError("Error: Role not recognized.");
          setLoading(false);
      }
      
      // ⏱️ End timing for role processing
      console.timeEnd("  ⏱️ Step 4: Role processing & redirect");
      console.timeEnd("🔐 Total Login Time");
      
      // Log final summary
      const loginEndTime = performance.now();
      console.log(`✅ Login completed in ${(loginEndTime - loginStartTime).toFixed(2)}ms for role: ${userRole}`);
      
    } catch (err) {
      // ⏱️ End timing on error
      console.timeEnd("🔐 Total Login Time");
      console.error("❌ Login failed:", err.code || err.message);
      
      setLoading(false);

      let errorReason = "Unknown error";
      let displayMessage = "Wrong credentials - invalid username or password.";

      if (
        err.code === "auth/wrong-password" ||
        err.code === "auth/user-not-found"
      ) {
        errorReason = "Invalid credentials";
        displayMessage = "Wrong credentials - invalid username or password.";
      } else if (err.code === "auth/invalid-email") {
        errorReason = "Invalid email format";
        displayMessage =
          "The email address is badly formatted. Please enter a valid email.";
      } else if (err.code === "auth/network-request-failed") {
        errorReason = "Network error";
        displayMessage =
          "Network error. Please check your connection and try again.";
      } else {
        errorReason = "Unknown login error";
        displayMessage = "Wrong credentials - invalid username or password.";
      }

      setError(displayMessage);
      toast.error(displayMessage); // ✅ ADDED TOAST HERE

      // ✅ Log failed login to Firebase
      logFailedLogin(email, errorReason, { ip_address: "client-ip" });
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // return (

  return (
    // ✅ Show Login Form if Privacy Policy is already accepted
    <div
      style={{
        position: "relative",
        height: "100vh",
        width: "100vw",
        overflow: "hidden!important",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: "url('/scan.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          // filter: 'blur(8px)',
          opacity: 0.9,

          zIndex: -1,
        }}
      ></div>
      <div className="page-container">
        <div className="heading-container">
          <span className="main-heading">ImagiXAI</span>
          <span className="sub-heading">
            A Lifesaving Breakthrough in Every Scan
          </span>
        </div>

        <div className="main-container">
          <div className="login-wrapper">
            <div className="login-panel">
              <form className="loginForm" onSubmit={handleSubmit}>
                {error && (
                  <Alert className="loginError" variant="danger">
                    {error}
                  </Alert>
                )}
                <h3 className="login-title">LOGIN</h3>
                <div className="input-group">
                  <span className="input-icon">
                    <i className="fas fa-user"></i>
                  </span>
                  <input
                    type="email"
                    id="userEmail"
                    className="login-input"
                    placeholder="Username"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="input-group">
                  <span className="input-icon">
                    <i className="fas fa-lock"></i>
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="userPassword"
                    className="login-input"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className="password-toggle"
                    onClick={handleShowPassword}
                  >
                    {showPassword ? (
                      <i className="fas fa-eye-slash"></i>
                    ) : (
                      <i className="fas fa-eye"></i>
                    )}
                  </span>
                </div>

                {/* ✅ Privacy Policy Full-Screen Modal with Background Blur */}
                {/* ✅ Privacy Policy Full-Screen Modal */}
                {/* ✅ Privacy Policy Full-Screen Modal */}
                {showPrivacyPolicy && (
                  <div className="privacy-overlay">
                    <div className="privacy-modal">
                      {/* Close Button */}
                      <button
                        className="closeprivacy-btn"
                        onClick={() => setShowPrivacyPolicy(false)}
                      >
                        &times;
                      </button>

                      <h3>Privacy Policy</h3>

                      {/* ✅ Scrollable Privacy Policy Content */}
                      <div
                        className="privacy-content"
                        ref={policyRef}
                        onScroll={handleScroll}
                      >
                        <p>
                          At <strong>ImagiXAI</strong>, we value your privacy
                          and are committed to protecting your personal
                          information. This Privacy Policy outlines how we
                          collect, use, store, and protect your data when you
                          use our AI-powered connected care platform tailored
                          for radiology departments and hospitals.
                        </p>

                        <h4>1. Information We Collect</h4>
                        <p>
                          We may collect the following types of information:
                        </p>
                        <ul>
                          <li>
                            <strong>Personal Information:</strong> Names, email
                            addresses, phone numbers, and job roles of users
                            (Doctors, Radiologists, Admin, and Technician
                            teams). Login credentials and account details for
                            authentication purposes.
                          </li>
                          <li>
                            <strong>Medical Data:</strong> Medical images,
                            reports, and associated patient information uploaded
                            for analysis or collaboration. AI-generated triage
                            data and 3D models for medical purposes.
                          </li>
                          <li>
                            <strong>Usage Data:</strong> Log data including IP
                            addresses, browser type, and access times for
                            performance and security monitoring.
                          </li>
                          <li>
                            <strong>Cookies:</strong> We may use cookies to
                            enhance user experience and improve platform
                            functionality.
                          </li>
                        </ul>

                        <h4>2. How We Use Your Information</h4>
                        <p>
                          We use your information for the following purposes:
                        </p>
                        <ul>
                          <li>
                            Facilitating real-time collaboration between
                            doctors, radiologists, and care teams.
                          </li>
                          <li>
                            Processing and analyzing medical images using AI
                            tools.
                          </li>
                          <li>
                            Ensuring HIPAA compliance and maintaining the
                            security of medical data.
                          </li>
                          <li>
                            Improving our platform’s functionality and user
                            experience.
                          </li>
                          <li>
                            Responding to user inquiries and providing customer
                            support.
                          </li>
                        </ul>

                        <h4>3. Data Sharing and Disclosure</h4>
                        <p>
                          We do not sell or share your personal information with
                          third parties except:
                        </p>
                        <ul>
                          <li>
                            To authorized personnel within your organization
                            (e.g., care teams, radiologists).
                          </li>
                          <li>
                            To comply with legal obligations or government
                            requests.
                          </li>
                          <li>
                            To trusted third-party service providers assisting
                            with platform operations, under strict
                            confidentiality agreements.
                          </li>
                        </ul>

                        <h4>4. Data Security</h4>
                        <p>
                          We employ industry-standard security measures,
                          including encryption, to safeguard your data. Our
                          platform adheres to HIPAA compliance standards for the
                          secure handling of medical data.
                        </p>

                        <h4>5. Data Retention</h4>
                        <p>
                          We retain data for as long as necessary to fulfill the
                          purposes outlined in this policy or as required by
                          applicable laws. Users may request deletion of their
                          data by contacting us at{" "}
                          <strong>info@easiofy.com</strong>.
                        </p>

                        <h4>6. User Rights</h4>
                        <p>As a user, you have the right to:</p>
                        <ul>
                          <li>
                            Access, update, or delete your personal information.
                          </li>
                          <li>Restrict the processing of your data.</li>
                          <li>
                            Withdraw consent for data collection, where
                            applicable.
                          </li>
                        </ul>
                        <p>
                          To exercise your rights, please email us at{" "}
                          <strong>info@easiofy.com</strong>.
                        </p>

                        <h4>7. HIPAA Compliance</h4>
                        <p>
                          <strong>ImagiXAI</strong> is committed to meeting
                          HIPAA standards to protect the confidentiality and
                          integrity of medical data. All medical images and
                          patient data processed through our platform are
                          encrypted in transit and at rest.
                        </p>

                        <h4>8. AI Models</h4>
                        <p>
                          The AI models available on the platform are only to
                          assist the radiologists and the specialists.
                          Auto-generated reports by the software cannot be used
                          as the final report. Please treat this as a
                          provisional report and correlate clinically. For any
                          discrepancy, please consult a Radiologist/Physician.
                        </p>

                        <h4>9. Updates to This Policy</h4>
                        <p>
                          We may update this Privacy Policy periodically. Any
                          changes will be posted on this page with the updated
                          effective date.
                        </p>

                        <h4>10. Contact Us</h4>
                        <p>
                          If you have questions or concerns about this Privacy
                          Policy, please contact us at:
                        </p>
                        <p>
                          <strong>ImagiXAI Support</strong>
                          <br />
                          Email: <strong>info@easiofy.com</strong>
                        </p>
                      </div>

                      {/* ✅ Checkbox appears only after scrolling */}
                      {hasScrolledToBottom && (
                        <div className="checkbox-container">
                          <input
                            type="checkbox"
                            id="accept-privacy"
                            checked={acceptPolicy}
                            onChange={(e) => setAcceptPolicy(e.target.checked)}
                          />
                          <label htmlFor="accept-privacy">
                            I have read and accept the Privacy Policy.
                          </label>
                        </div>
                      )}

                      {/* ✅ Accept Button - Disabled until checkbox is checked */}
                      <button
                        className="accept-btn"
                        onClick={handleAcceptPrivacy}
                        disabled={!acceptPolicy}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                )}

                <button
                  className="login-button"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Signing In..." : "Sign in"}
                </button>
                <div className="forgot-password">
                  <button
                    type="button"
                    className="forgot-password-link"
                    onClick={handleforgotpassword}
                  >
                    Forgot Password?
                  </button>
                </div>
                <div className="privacy-policy-link">
                  <p>
                    By signing in, you agree to our{" "}
                    <Link to="/privacypolicy">Privacy Policy</Link>.
                  </p>
                </div>
                {loading && (
                  <div className="spinner-overlay">
                    <div className="spinner"></div>
                    <p>Please wait...</p>
                  </div>
                )}
              </form>
            </div>
            <ToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;